import axios, { type InternalAxiosRequestConfig } from "axios";
import { fetchSession } from "../auth";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

apiClient.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const tokenInfo = await fetchSession();
  config.headers.Authorization = `Bearer ${tokenInfo.accessToken}`;
  return config;
});

export default apiClient;
